import React, { useRef } from 'react';
import store from 'store';
import { useRouteMatch, Switch, useHistory, Route, Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Formik, Form } from 'formik';
import { Persist } from 'formik-persist';
import { getMobileNutritionRoutes } from '../../../routes/mobile/speak-doctor/nutritionRoutes';
import LoadingSpinner from '../../../components/common/LoadingSpinner';
import HeaderBack from '../../../components/mobile/speak-doctor/HeaderBack';
import PregnantNavBtn from '../../../components/mobile/speak-doctor/PregnantNavBtn';
import { errorNotification } from '../../../utils/notification-helpers';
import { postScreeningAPICall } from '../../../api/speak-doctor';
import AuthGuestLoggedin from '../../../services/AuthGuestLoggedinService';
import { MENTAL_HEALTH_QUESTION_HEALTH_CONCERN_APPOINTMENT } from '../../../config/constants';

const authCheck = new AuthGuestLoggedin()

const NutritionWrapper = ({title, subtitle, prevRoutePath, textPrevHeaderPath, isFirst, children, ...restNavBtnProps }) => (
  <>
    <HeaderBack
      previousPage={prevRoutePath}
      text={textPrevHeaderPath}
      title={title}
      subtitle={subtitle}
    />
    {children}
    <PregnantNavBtn isFirst={isFirst} prevRoutePath={prevRoutePath} {...restNavBtnProps} />
  </>
);

function MobileNutritionScreen() {
  const { t } = useTranslation(['common', 'speak-doctor']);
  const match = useRouteMatch();
  const history = useHistory();
  const ref = useRef(null);

  const { path } = match;

  const initialValues = {
    HowManyPeopleDoYouLiveWith: 0,
    HowOftenFeelQualityFood: 1,
    IssueToDiscussWithDoctor: ''
  };

  const renderRoutes = (routes, total = routes.length) =>
    routes.map(({ id: count, path: p, component: Component, props: componentProps }) => {
      const {
        nextRoutePath,
        prevRoutePath,
        additionalRoute,
        recommendedRoute,
        options,
        isMultiSelect,
        ...restComponentProps
      } = componentProps;

      // if(employeeStatus.covid_screening_done){
      //   return <Redirect to={{ pathname: '/welcome/status' }} />
      // }

      return (
        <Route key={p} path={p}>
          <NutritionWrapper
            fieldName={componentProps.fieldName}
            isLast={componentProps.isLastQuestion}
            title={componentProps.title}
            subtitle={componentProps.subtitle}
            isFirst={componentProps.isFirst}
            textPrevHeaderPath={componentProps.textPrevHeaderPath}
            prevRoutePath={prevRoutePath}
            nextRoutePath={nextRoutePath}
            additionalRoute={additionalRoute}
          >
            <Component
              options={options}
              isMultiSelect={isMultiSelect}
              {...restComponentProps}
            />
          </NutritionWrapper>
        </Route>
      );
    });

  return (
    <>
      <Formik
        innerRef={ref}
        enableReinitialize
        initialValues={initialValues}
        onSubmit={async (values, { setSubmitting, resetForm }) => {
          const answers = { ...values };

          try {
            const { responseOk, responseJSON } = await postScreeningAPICall({
              nutrition: answers
            });
            store.set(MENTAL_HEALTH_QUESTION_HEALTH_CONCERN_APPOINTMENT, values.IssueToDiscussWithDoctor)
            setSubmitting(false);
            resetForm({ values: initialValues });
            if (!responseOk) {
              throw new Error(`${responseOk} - ${responseJSON}`);
            }
            authCheck.redirectSpeakDoctor()
          } catch (err) {
            console.error(err);
            errorNotification(t('common:form.error.submit'));
            setSubmitting(false);
            resetForm({ values: initialValues });
            history.push(`/speak-doctor/nutrition/how-many-people-live`);
          }
        }}
      >
        {({ isSubmitting }) => (
          <Form loading={isSubmitting.toString()}>
            <>
              {isSubmitting}
              <Switch>
                {renderRoutes(
                  getMobileNutritionRoutes(),
                  getMobileNutritionRoutes().length - 1
                )}
                <Redirect to={`${path}/how-many-people-live`} />
              </Switch>
            </>
            {!isSubmitting && <Persist name="nutrition-screening-form" />}
            {isSubmitting ? (
              <LoadingSpinner position="full" transparent={false} />
            ) : null}
          </Form>
        )}
      </Formik>
    </>
  );
}

const styles = {
  title: {
    fontWeight: "400", 
    fontSize: "18px", 
    lineHeight: "26px", 
    textAlign: "center", 
    letterSpacing: "0.02em", 
    color: "#404047"
  },
  divider: {
    fontSize: 15,
    fontWeight: 400,
    color: '#404047',
    margin: 0
  },
  selectOption: {
    fontWeight: "300", 
    fontSize: "15px", 
    lineHeight: "20px", 
    textAlign: "center", 
    letterSpacing: "0.02em", 
    color: "#15A9E1"
  }
}

export default MobileNutritionScreen;
